/**
 * Feature 10 — Locked legal disclaimer copy.
 *
 * Adopted verbatim from the CTO handoff (spec §951-1064).  Do NOT
 * paraphrase or shorten any string here — changes must come through
 * the spec.
 */
import { useState } from 'react';


export const DISCLAIMER_FULL =
  'GuardGrade scores are based on submitted operational data, '
  + 'available site context, and observed reporting/activity patterns. '
  + 'GuardGrade is not a full contract compliance audit, legal '
  + 'certification, employment screening report, '
  + 'insurance/credit/housing eligibility tool, or guarantee of future '
  + 'security outcomes. Scores should be considered one performance '
  + 'insight layer alongside licensing, insurance, references, site '
  + 'audits, contract review, and management judgment.';


export const DISCLAIMER_SHORT =
  'GuardGrade is performance insight based on submitted data. Not a '
  + 'compliance audit or guarantee.';


function DisclaimerModal({ onClose }: { onClose: () => void }) {
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 p-4" onClick={onClose}>
      <div className="bg-white rounded-2xl shadow-xl max-w-lg w-full p-6" onClick={(e) => e.stopPropagation()}>
        <h2 className="text-sm font-semibold text-slate-900">About GuardGrade Scores</h2>
        <p className="mt-3 text-xs leading-5 text-slate-600">{DISCLAIMER_FULL}</p>
        <div className="mt-6 flex justify-end">
          <button
            onClick={onClose}
            className="rounded-lg bg-slate-800 px-4 py-2 text-xs font-semibold text-white hover:bg-slate-900"
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
}


interface Props {
  variant: 'full' | 'short';
  className?: string;
}


export default function ScoreDisclaimer({ variant, className = '' }: Props) {
  const [open, setOpen] = useState(false);
  if (variant === 'full') {
    return (
      <p className={`text-xs leading-5 text-slate-500 ${className}`}>
        {DISCLAIMER_FULL}
      </p>
    );
  }
  return (
    <>
      <p className={`text-xs text-slate-500 ${className}`}>
        {DISCLAIMER_SHORT}{' '}
        <button
          type="button"
          onClick={() => setOpen(true)}
          className="underline hover:text-slate-700"
        >
          Read more
        </button>
      </p>
      {open && <DisclaimerModal onClose={() => setOpen(false)} />}
    </>
  );
}
